import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ImageDTO } from "../../models/DTO/image/imageDTO";

export const Convertor = {
    convertDate: {
        pointToBackslash: function(date: string) {
            var d = new Date(date),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();
            
            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;
        
            return [day, month, year].join('/');
        },
        pointToDash: function(date: string) {
            var d = new Date(date),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();
            
            if (month.length < 2) 
                month = '0' + month;
            if (day.length < 2) 
                day = '0' + day;
        
            return [year, month, day].join('-');
        }
    },
    convertAttributeName: {
        convertFromAPI: function(attrName: string) {
            let converted = attrName.replace("Attr", '');
            return converted[0].toUpperCase() + converted.substr(1);
        }
    },
    convertImages: {
        plainToFullBase64: function(plainBase64: string, type: string) {
            return 'data:image/' + type.replace('.', '') + ';base64,' + plainBase64;
        },

        getSanitizedImage: function(domSanitizer: DomSanitizer, image: ImageDTO) : SafeResourceUrl  {
            const imageContent = Convertor.convertImages.plainToFullBase64(image.content, image.contentContentType);
            return domSanitizer.bypassSecurityTrustResourceUrl(imageContent);
        },
        
        fullBase64ToFiltered: function(fullBase64: string) {
            return fullBase64.substring(fullBase64.indexOf(',') + 1);
        }
    },


}